import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import IButton from "Screens/components/iButton";
import * as Icons from "react-bootstrap-icons";
import { get_blogs } from "http/components/Requests";
import CheckApiStatus from "Utils/Constants/CheckApiStatus";
import { set_BlogData } from "../../../Redux/slices/dataSlice";
import { decodeText } from "Utils/Helpers/TextDecoder";
import BlogHead from "./BlogHead";

export default function BlogSingle({}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  let params = useParams();
  const { t } = useTranslation();
  const [data, setData] = useState(null);
  const { blog } = useSelector((state) => ({
    blog: state.data.blog,
  }));

  useEffect(() => {
    if (blog && params && params.id) {
      setData(blog.find((item) => item.id === params.id));
    } else {
      blogs();
    }
  }, [blog]);

  const blogs = async () => {
    const response = await get_blogs();
    if (CheckApiStatus(response)) {
      dispatch(set_BlogData(response.data.infos));
    }
  };

  const onBack = (id) => {
    navigate("/blogs");
  };

  return (
    <>
      {data && (
        <div className="blog-single">
          <div className="blog-single-prop">
            <IButton
              label={t("Back")}
              icon={<Icons.CaretLeft />}
              onClick={onBack}
              className={"fullWidth"}
            />
            <div className="prop-image">
              <img src={data.image} alt={data.id} />
            </div>
            <div className="blog-tags">
              {data.tags.split(",").map((i, index) => {
                return (
                  <p key={`tags-${data.id}-${index}`}>
                    <span>#</span>
                    {i}
                  </p>
                );
              })}
            </div>
          </div>
          <div className="blog-single-content">
            <BlogHead item={data} />
            <div className="content-body">
              <div
                className="content-body"
                dangerouslySetInnerHTML={{
                  __html: decodeText(t(data.description)),
                }}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
}
